export const tutorials = [
  {
    id: 1,
    title: "Getting Started with AI in Education",
    duration: "5 min",
    description:
      "Learn the basics of AI and how it can enhance your educational experience",
    topics: [
      "What is AI?",
      "Educational Applications",
      "Ethical Considerations",
    ],
    videoUrl: "https://youtu.be/akQPQfOmW4E",
    embedType: "youtube", // or "vimeo" or "direct"
  },
  {
    id: 2,
    title: "Email Assistant Walkthrough",
    duration: "6 min",
    description: "Step-by-step guide to using the Smart Email Assistant",
    topics: [
      "Interface Overview",
      "Writing Professional Emails",
      "Templates and Customization",
    ],
    videoUrl: "https://youtu.be/pMCWvVHFjH4",
    embedType: "youtube",
  },
  {
    id: 3,
    title: "Effective Note Summarization",
    duration: "7 min",
    description:
      "Master the art of converting long lectures into concise, useful summaries",
    topics: ["Input Preparation", "Summary Types", "Organizing Results"],
    videoUrl: "https://youtu.be/0cgbg-fATHU",
    embedType: "youtube",
  },
  {
    id: 4,
    title: "Prompt Engineering Fundamentals",
    duration: "7 min",
    description: "Learn to write effective prompts for better AI responses",
    topics: ["Prompt Structure", "Role Definition", "Context Setting"],
    videoUrl: "https://youtu.be/Dl160PMytwk",
    embedType: "youtube",
  },
  {
    id: 5,
    title: "Academic Integrity and AI",
    duration: "5 min",
    description: "Understanding ethical AI usage in academic settings",
    topics: [
      "Guidelines and Policies",
      "Appropriate Usage",
      "Saftey and Privacy",
    ],
    videoUrl: "https://youtu.be/axaYoQxcICo",
    embedType: "youtube",
  },
  {
    id: 6,
    title: "Research Assistant Best Practices",
    duration: "10 min",
    description: "Maximize your research efficiency with Advanced Techniques",
    topics: ["Advanced Features", "Reasoning Modes", "Research Techniques"],
    videoUrl: "https://youtu.be/F_Rw1MyCOdM",
    embedType: "youtube",
  },
];
